import { useState, useEffect } from "react";
import "./index.css";
import velimage from "../../assets/images/Asset 19 4.png";
import { useLocation, useNavigate } from "react-router-dom";
import SideBarlogo from "../../assets/images/sidebar-logo1 (1).png";
// import Sidebarlogo1 from "../../assets/images/sidebar-logo1 (1).png";
import Sidebarlogo1 from "../../assets/images/Asset 12 5.png";

import translations from "../Translations";

export default function Sidenav({ isCollapsed, isMobileOpen, closeMobile,  isHovered,
  onMouseEnter,
  onMouseLeave }) {
    const navigate = useNavigate();
    const location = useLocation();
  const [lang, setLang] = useState("en");
 const t = (key) => translations[lang][key] || key;

 useEffect(() => {
    const savedLang = localStorage.getItem("lang");
    if (savedLang) setLang(savedLang);
  }, []);

  return (
    <>
      {isMobileOpen && <div className="overlay" onClick={closeMobile}></div>}

      <div
        className={`sidenav 
        ${isCollapsed ? "collapsed" : ""} 
        ${isMobileOpen ? "open" : ""}`}
        onMouseEnter={onMouseEnter}   
  onMouseLeave={onMouseLeave}
      >

      <div className="logo">
  {(!isCollapsed || isHovered) ? (
    <img
      style={{ width: '220px', objectFit: 'cover', marginBottom: '15px' }}
      src={Sidebarlogo1}
      alt="logo"
    />
  ) : (
    <img
      src={velimage}
      alt="vel"
      style={{
        width: '50px',
        height: '120px',
        // objectFit: 'cover',
        // borderRadius: '8px'
      }}
    />
  )}
</div>


<div className={`menu ${lang === "ta" && "fs-tamil"}`}>
        <div
  className={`menu-item ${location.pathname === "/dashboard" ? "active" : ""}`}
  onClick={() => navigate("/dashboard")}
>
  <i className="fas fa-chart-line"></i>
  <span>{t("dashboard")}</span>
</div>

<div
  className={`menu-item ${location.pathname.includes("/customer") ? "active" : ""}`}
  onClick={() => navigate("/customer-list")}
>
  <i className="fas fa-users"></i>
 <span style={{ fontSize: lang === "ta" ? "15px" : "" }}>
  {t("customers")}
</span>
</div>

<div
  className={`menu-item ${location.pathname==="/collections" ? "active" : ""}`}
  onClick={() => navigate("/collections")}
>
  <i className="fa-solid fa-box"></i>
 <span style={{ fontSize: lang === "ta" ? "15px" : "" }}>
 {t("Collection")}
</span>
</div>

 <div
  className={`menu-item ${location.pathname==="/reports" ? "active" : ""}`}
  onClick={() => navigate("/reports")}
>
  <i className="fa-solid fa-file-alt"></i>
 <span style={{ fontSize: lang === "ta" ? "15px" : "" }}>
 {t("reports")}
</span>
</div>

<div
  className={`menu-item ${location.pathname === "/profile-settings" ? "active" : ""}`}
  onClick={() => navigate("/profile-settings")}
>
  <i className="fas fa-cog"></i>
    <span>{t("settings")}</span>
</div>

        </div>
      </div>
    </>
  );
}